import { OverlayModule } from '@angular/cdk/overlay';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CoreUiTooltipDirective } from './tooltip/core-ui-tooltip.directive';
import { SimpleTooltipDirective } from './simple-tooltip/simple-tooltip.directive';
import { MousePositionDirective } from './mouse-position/mouse-position.directive';
import { CoreUiHorizontalDragScrollDirective } from './horizontal-drag-scroll/horizontal-drag-scroll.directive';
import { CoreUIMediaHoverPreviewPanelComponent } from './media-hover-preview/media-hover-preview-panel.component';
import { CoreUIMediaHoverPreviewDirective } from './media-hover-preview/media-hover-preview.directive';

@NgModule({
    declarations: [
        CoreUiTooltipDirective,
        SimpleTooltipDirective,
        MousePositionDirective,
        CoreUiHorizontalDragScrollDirective,
        CoreUIMediaHoverPreviewPanelComponent,
        CoreUIMediaHoverPreviewDirective
    ],
    imports: [CommonModule, OverlayModule],
    exports: [
        CoreUiTooltipDirective,
        SimpleTooltipDirective,
        MousePositionDirective,
        CoreUiHorizontalDragScrollDirective,
        CoreUIMediaHoverPreviewDirective
    ]
})
export class CoreUiDirectivesModule { }
